import { useCallback, useContext } from 'react'
import dynamic from 'next/dynamic'

const G4DTextChecker = dynamic(() => import('./g4d').then((mod) => mod.G4DTextChecker))

import { gnarClient, EventProps } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'

interface TextCheckerEditorPluginProps {
  createDocument: (text: string) => Promise<string>
  isWordCounter: boolean
  autofocus?: boolean
  bottomSectionLabel?: string
  slug?: string
}

export const TextCheckerEditorPlugin = (props: TextCheckerEditorPluginProps) => {
  const { autofocus, isWordCounter, bottomSectionLabel } = props
  const { pageId, slug } = useContext(PageContext)

  const gnarTrackFn = useCallback(
    (trackEventProps: EventProps) => {
      return gnarClient.track({ ...trackEventProps, pageId, pageSlug: slug })
    },
    [pageId, slug]
  )
  const placeholder = 'Start writing here.'

  return (
    <G4DTextChecker
      gnarTrackFn={gnarTrackFn}
      placeholder={placeholder}
      isWordCounter={isWordCounter}
      autofocus={autofocus}
      bottomSectionLabel={bottomSectionLabel}
      slug={slug}
    />
  )
}
